import {
  CurrencyCode,
  DiscountType,
  ExpenseType,
  FinanceType,
  ProductTemplateType,
  ProductType,
  ProductVatType,
  TaxTypeId,
  TransactionType,
  WhtAmountType,
} from "@/enums/enums";
import peakUtility from "@/helper/peakUtility";
import { ClassificationItemListModel, ClassificationListModel } from "@/model/classification";
import { GetWhtAmountValue } from "./shareHelper";
const vatPercent = 7;
const inputMaxNumber = 999999999.9999;
const inputMinNumber = -999999999.9999;
export function GetCreateTransactionSummaryDefualt(isEditVatDisabled = false) {
  return {
    vatExemptedTotal: "0.00",
    zeroVatTotal: "0.00",
    vat: {
      preVatTotalDefualt: "0.00",
      preVatTotal: "0.00",
      vatTotalDefualt: "0.00",
      vatTotal: "0.00",
      disabled: isEditVatDisabled,
      isActive: false,
      vatTotalBeforeEdit: "0.00",
    },
    netAmount: "0.00",
    paymentWht: {
      whtTotal: 0,
      paymentNetAmount: 0,
      isShow: false,
    },
    subTotalForCalculateWht: 0,
    isNoneOrNotSpecifyWht: GetWhtAmountValue(WhtAmountType.NotSpecify),
    remainPaymentNetAmount: 0,
    remainWhtPaymentNetAmount: 0,
    sameProductVatType: 0,
    isServiceOnly: false,
    sameProductVatTypeIdTransactionItemTypeProduct: 0,
    discount: 0,
  };
}

export function Base64ToBlob(base64: any, fileType: any) {
  const binaryString = atob(base64.split(",")[1]);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return new Blob([bytes], { type: fileType });
}

export function GetCreateTransactionCurrencySummaryDefualt(isEditVatDisabled = false) {
  return {
    vatExemptedTotal: "0.00",
    zeroVatTotal: "0.00",
    vat: {
      preVatTotalDefualt: "0.00",
      preVatTotal: "0.00",
      vatTotalDefualt: "0.00",
      vatTotal: "0.00",
      disabled: isEditVatDisabled,
      isActive: false,
      vatTotalBeforeEdit: "0.00",
    },
    netAmount: "0.00",
    fromCurrencyUId: 0,
    toCurrencyUId: 0,
    disabled: isEditVatDisabled,
    hidden: isEditVatDisabled,
    exchangeRate: 1,
    currencyCode: "THB",
    ratio: 1,
    hiddenExchangeRate: true,
    isGetSuggestionCurrency: false,
    whtTotal: 0,
    amountBeforeDiscount: "0.00",
    amountAfterDiscount: "0.00",
    referenceDepositTotal: "0.00",
    discount: 0,
  };
}

export function GetCreateReferenceDepositSummaryDefualt() {
  return {
    fromCurrencyDepositVatTotal: "0.00",
    fromCurrencyDepositPreVatTotal: "0.00",
    fromCurrencyDepositZeroVatTotal: "0.00",
    fromCurrencyDepositVatExemptedTotal: "0.00",
    toCurrencyDepositVatTotal: "0.00",
    toCurrencyDepositPreVatTotal: "0.00",
    toCurrencyDepositZeroVatTotal: "0.00",
    toCurrencyDepositVatExemptedTotal: "0.00",
  };
}

function DoGetCreateTransactionItemDefualt(expenseType = ExpenseType.None) {
  const hiddenProduct = expenseType == ExpenseType.Expense || expenseType == ExpenseType.PurchaseAsset;
  const hiddenAsset = expenseType == ExpenseType.Expense || expenseType != ExpenseType.PurchaseAsset;
  return {
    isDescriptionOnly: false,
    isValidateError: false,
    productTemplate: {
      id: 0,
      code: "",
      name: "",
      disabled: false,
      hidden: hiddenProduct,
      productTypeId: 2,
      isNotAuto: false,
      validateError: false,
    },
    fixedAssetTemplate: {
      id: 0,
      code: "",
      name: "",
      disabled: false,
      hidden: hiddenAsset,
      fixedAssetTypeId: 1,
      isNotAuto: false,
    },
    account: {
      id: 0,
      code: "",
      name: "",
      taxIncomeTypeId: 0,
      disabled: false,
      isNotAuto: false,
    },
    description: {
      text: "",
      disabled: false,
      validateError: false,
    },
    unit: {
      id: 0,
      name: "",
      disabled: false,
    },
    amount: {
      value: "1.00",
      disabled: false,
      validateError: false,
    },
    price: {
      value: "0.00",
      disabled: false,
      validateError: false,
    },
    discount: {
      value: "0.00",
      disabled: false,
      discountTypeId: DiscountType.Currency,
      validateError: false,
    },
    vatTypeId: {
      value: 3,
      disabled: false,
      isSuggestion: false,
    },
    itemPreVatTotal: "0.00",
    itemVatTotal: "0.00",
    itemNetTotal: "0.00",
    itemWht: {
      text: "",
      value: null,
      percent: 0,
      whtAmountType: -2,
      disabled: false,
      validateError: false,
      isNotAuto: false,
    },
    classificationTransactionList: [],
    fromCurrencyPrice: 0,
    fromCurrencyDiscount: 0,
    fromCurrencyWHTTotal: 0,
    fromCurrencyNetTotal: 0,
    fromCurrencyVatTotal: 0,
    fromCurrencyPreVatTotal: 0,
    fromCurrencyZeroVatTotal: 0,
    fromCurrencyVatExemptedTotal: 0,
    fromCurrencySubTotalForcalculateWHT: 0,
    toCurrencyPrice: 0,
    toCurrencyDiscount: 0,
    toCurrencyWHTTotal: 0,
    toCurrencyNetTotal: 0,
    toCurrencyVatTotal: 0,
    toCurrencyPreVatTotal: 0,
    toCurrencyZeroVatTotal: 0,
    toCurrencyVatExemptedTotal: 0,
    toCurrencySubTotalForcalculateWHT: 0,
  };
}

export function GetCreateTransactionItemDefualt(expenseType = ExpenseType.None) {
  return DoGetCreateTransactionItemDefualt(expenseType);
}
function GetTransactionItemWhtPercent(whtAmountType: any) {
  let transactionItemWhtPercent: any = 0;
  switch (whtAmountType) {
    case WhtAmountType.NotSpecify:
      transactionItemWhtPercent = GetWhtAmountValue(WhtAmountType.NotSpecify);
      break;
    case WhtAmountType.None:
      transactionItemWhtPercent = GetWhtAmountValue(WhtAmountType.None);
      break;
    case WhtAmountType.ZeroPointSevenFive:
      transactionItemWhtPercent = GetWhtAmountValue(WhtAmountType.ZeroPointSevenFive);
      break;
    case WhtAmountType.OnePercent:
      transactionItemWhtPercent = GetWhtAmountValue(WhtAmountType.OnePercent);
      break;
    case WhtAmountType.OnePointFivePercent:
      transactionItemWhtPercent = GetWhtAmountValue(WhtAmountType.OnePointFivePercent);
      break;
    case WhtAmountType.TwoPercent:
      transactionItemWhtPercent = GetWhtAmountValue(WhtAmountType.TwoPercent);
      break;
    case WhtAmountType.ThreePercent:
      transactionItemWhtPercent = GetWhtAmountValue(WhtAmountType.ThreePercent);
      break;
    case WhtAmountType.FivePercent:
      transactionItemWhtPercent = GetWhtAmountValue(WhtAmountType.FivePercent);
      break;
    case WhtAmountType.TenPercent:
      transactionItemWhtPercent = GetWhtAmountValue(WhtAmountType.TenPercent);
      break;
    case WhtAmountType.FifteenPercent:
      transactionItemWhtPercent = GetWhtAmountValue(WhtAmountType.FifteenPercent);
      break;
    case WhtAmountType.Custom:
      transactionItemWhtPercent = GetWhtAmountValue(WhtAmountType.Custom);
      break;
  }
  return transactionItemWhtPercent;
}

function CalculateWithCurrencyUid(currencyAmount: any, exchangeRates: any, currencyRatio: any, toCurrencyUid: any) {
  if (toCurrencyUid === CurrencyCode.THB) {
    return currencyAmount;
  } else {
    const netAmount = peakUtility.PeakOperatorDivide(
      peakUtility.PeakOperatorMultiply(currencyAmount, exchangeRates),
      currencyRatio
    );
    return netAmount;
  }
}

function GetTransactionItemList(_transaction: any) {
  const transactionItemList = [];
  if (_transaction.transactionItemList.length > 0) {
    let total = 0;
    let totalForCalculateTransactionDiscount = 0;
    let sameProductVatTypeId = 0;
    let isServiceOnly = false;
    let isHaveProductTemplate = false;
    let isHaveProductTemplateTypeProduct = false;
    let sameProductVatTypeIdTransactionItemTypeProduct = 0;
    let dummyTransactionItemVatTypeId = 0;
    let dummyTransactionItemProductVatTypeId = 0;
    let countTransactionItemWithoutDescriptionOnly = 0;
    let countTransactionItemTypeProductWithoutDescriptionOnly = 0;

    const currencyExchangeRates = _transaction.transactionCurrencySummary.exchangeRate;
    const currencyRatio = _transaction.transactionCurrencySummary.ratio;
    const currencyUId = _transaction.transactionCurrencySummary.toCurrencyUId;

    const isNoneOrNotSpecifyWht = _transaction.transactionItemList.some((transactionItem: any) => {
      const whtAmountType = transactionItem.itemWht.whtAmountType;

      if (whtAmountType === WhtAmountType.NotSpecify || whtAmountType === WhtAmountType.None) {
        return true;
      }

      if (whtAmountType === WhtAmountType.Custom && !transactionItem.itemWht.value) {
        return true;
      }

      return false;
    });

    for (let sequenceNumber = 0; sequenceNumber < _transaction.transactionItemList.length; sequenceNumber++) {
      const _transactionItem = _transaction.transactionItemList[sequenceNumber];
      const isDescriptionOnly = _transactionItem.isDescriptionOnly;
      let accountId = 0;
      let transactionItemPrice = 0;
      let transactionItemAmount = 0;
      let transactionItemDiscount = 0;
      let transactionItemDiscountTypeId = 0;
      let transactionItemVatTypeId = 0;
      let transactionItemWhtAmountTypeId = -2;
      let transactionItemWhtAmount: any = 0;
      let productTemplateId = 0;
      const transactionItemDescription = _transactionItem.description;
      let fixedAssetTemplateId = 0;
      let transactionItemTotal = 0;
      let transactionItemTypeId = 2;
      let taxIncomeTypeId = 0;
      let transactionItemPreVatAmount = 0;
      let transactionItemVatAmount = 0;
      if (!isDescriptionOnly) {
        countTransactionItemWithoutDescriptionOnly++;
        accountId = _transactionItem.account.id.ToNumber();
        transactionItemPrice = _transactionItem.price.value.ToNumber();
        transactionItemAmount = _transactionItem.amount.value.ToNumber();
        taxIncomeTypeId = _transactionItem.account.taxIncomeTypeId.ToNumber();
        const discountValue = _transactionItem.discount.value;
        if (_transactionItem.discount.discountTypeId == 1) {
          transactionItemDiscount = discountValue.ToNumber();
          transactionItemDiscountTypeId = 1;
        } else {
          transactionItemDiscount = discountValue.ToNumber();
          transactionItemDiscountTypeId = 0;
        }
        if (_transaction.taxStatus.value == TaxTypeId.None) {
          _transactionItem.vatTypeId.value = ProductVatType.None;
        }
        transactionItemVatTypeId = _transactionItem.vatTypeId.value;
        if (countTransactionItemWithoutDescriptionOnly === 1) {
          dummyTransactionItemVatTypeId = transactionItemVatTypeId;
          sameProductVatTypeId = transactionItemVatTypeId;
        }
        if (dummyTransactionItemVatTypeId !== transactionItemVatTypeId) {
          sameProductVatTypeId = 0;
        }
        productTemplateId = _transactionItem.productTemplate.id;
        fixedAssetTemplateId = _transactionItem.fixedAssetTemplate.id;
        if (productTemplateId > 0) {
          transactionItemTypeId = _transactionItem.productTemplate.productTypeId;
        } else if (fixedAssetTemplateId > 0) {
          transactionItemTypeId = _transactionItem.fixedAssetTemplate.fixedAssetTypeId;
        }

        if (productTemplateId > 0 || fixedAssetTemplateId > 0) {
          isHaveProductTemplate = true;
          if (transactionItemTypeId == ProductTemplateType.Product) {
            countTransactionItemTypeProductWithoutDescriptionOnly++;
            isHaveProductTemplateTypeProduct = true;

            if (countTransactionItemTypeProductWithoutDescriptionOnly === 1) {
              dummyTransactionItemProductVatTypeId = transactionItemVatTypeId;
              sameProductVatTypeIdTransactionItemTypeProduct = transactionItemVatTypeId;
            }

            if (dummyTransactionItemProductVatTypeId !== transactionItemVatTypeId) {
              sameProductVatTypeIdTransactionItemTypeProduct = 0;
            }
          }

          if (transactionItemTypeId == ProductTemplateType.Service && !isHaveProductTemplateTypeProduct) {
            isServiceOnly = true;
          } else {
            isServiceOnly = false;
          }
        }

        if (accountId > 0 && !isHaveProductTemplate) {
          isServiceOnly = true;
        }

        let transactionItemPriceTotal = 0;
        if (transactionItemDiscountTypeId === 1) {
          transactionItemPriceTotal = peakUtility.PeakOperatorSubtract(
            transactionItemPrice,
            peakUtility.PeakOperatorDivide(
              peakUtility.PeakOperatorMultiply(transactionItemPrice, transactionItemDiscount),
              100
            )
          );
        } else {
          transactionItemPriceTotal = peakUtility.PeakOperatorSubtract(transactionItemPrice, transactionItemDiscount);
        }
        transactionItemTotal = peakUtility.PeakOperatorMultiply(transactionItemPriceTotal, transactionItemAmount);
        total = peakUtility.PeakOperatorAdd(total, transactionItemTotal);
        totalForCalculateTransactionDiscount = peakUtility.PeakOperatorAdd(
          totalForCalculateTransactionDiscount,
          transactionItemTotal > 0 ? transactionItemTotal : 0
        );
        if (_transaction.taxStatus.value === TaxTypeId.IncludeTax) {
          if (_transactionItem.vatTypeId.value === ProductVatType.SevenPercent) {
            transactionItemPreVatAmount = peakUtility.PeakOperatorMultiply(
              peakUtility.PeakOperatorDivide(transactionItemTotal, peakUtility.PeakOperatorAdd(100, 7)),
              100
            );
            transactionItemVatAmount = peakUtility.PeakOperatorSubtract(
              transactionItemTotal,
              transactionItemPreVatAmount
            );
          } else {
            transactionItemPreVatAmount = transactionItemTotal;
          }
        } else {
          transactionItemPreVatAmount = transactionItemTotal;
          if (_transactionItem.vatTypeId.value === ProductVatType.SevenPercent) {
            transactionItemVatAmount = peakUtility.PeakOperatorMultiply(
              transactionItemTotal,
              peakUtility.PeakOperatorDivide(7, 100)
            );
          }
        }
        transactionItemWhtAmountTypeId = _transactionItem.itemWht.whtAmountType;
        _transactionItem.itemWht.percent = GetTransactionItemWhtPercent(transactionItemWhtAmountTypeId);
        if (transactionItemWhtAmountTypeId === WhtAmountType.NotSpecify) {
          transactionItemWhtAmount = null;
          _transactionItem.itemWht.value = null;
        } else if (transactionItemWhtAmountTypeId === WhtAmountType.None) {
          transactionItemWhtAmount = 0;
          _transactionItem.itemWht.value = 0;
        } else if (transactionItemWhtAmountTypeId === WhtAmountType.Custom) {
          transactionItemWhtAmount = _transactionItem.itemWht.value ? _transactionItem.itemWht.value.ToNumber() : 0;
        } else {
          transactionItemWhtAmount = peakUtility.PeakOperatorDivide(
            peakUtility.PeakOperatorMultiply(transactionItemPreVatAmount, _transactionItem.itemWht.percent),
            100
          );
          _transactionItem.itemWht.value = transactionItemWhtAmount;
        }

        _transactionItem.itemPreVatTotal = transactionItemPreVatAmount.FormatMoney();
        _transactionItem.itemVatTotal = transactionItemVatAmount.FormatMoney();
        _transactionItem.itemNetTotal = peakUtility
          .PeakOperatorAdd(transactionItemPreVatAmount, transactionItemVatAmount)
          .FormatMoney();
      }

      _transactionItem.fromCurrencyPrice = 0;
      _transactionItem.fromCurrencyDiscount = 0;
      _transactionItem.fromCurrencyWHTTotal = 0;
      _transactionItem.fromCurrencyNetTotal = 0;
      _transactionItem.fromCurrencyVatTotal = 0;
      _transactionItem.fromCurrencyPreVatTotal = 0;
      _transactionItem.fromCurrencyZeroVatTotal = 0;
      _transactionItem.fromCurrencyVatExemptedTotal = 0;
      _transactionItem.fromCurrencySubTotalForcalculateWHT = 0;

      _transactionItem.toCurrencyPrice = _transactionItem.price.value.ToNumber();
      _transactionItem.toCurrencyDiscount = _transactionItem.discount.value.ToNumber();
      _transactionItem.toCurrencyWHTTotal = _transactionItem.itemWht.value
        ? _transactionItem.itemWht.value.ToNumber()
        : 0;
      _transactionItem.toCurrencyNetTotal = 0;
      _transactionItem.toCurrencyVatTotal = 0;
      _transactionItem.toCurrencyPreVatTotal = 0;
      _transactionItem.toCurrencyZeroVatTotal = 0;
      _transactionItem.toCurrencyVatExemptedTotal = 0;
      _transactionItem.toCurrencySubTotalForcalculateWHT = 0;

      switch (_transactionItem.vatTypeId.value) {
        case ProductVatType.SevenPercent:
          _transactionItem.toCurrencyVatTotal = transactionItemVatAmount;
          _transactionItem.toCurrencyPreVatTotal = transactionItemPreVatAmount;
          break;
        case ProductVatType.ZeroPercent:
          _transactionItem.toCurrencyZeroVatTotal = transactionItemTotal;
          break;
        case ProductVatType.None:
          _transactionItem.toCurrencyVatExemptedTotal = transactionItemTotal;
          break;
      }

      const subTotalTransactionItemForcalculateWHT =
        _transactionItem.toCurrencyPreVatTotal +
        _transactionItem.toCurrencyZeroVatTotal +
        _transactionItem.toCurrencyVatExemptedTotal;

      if (isNoneOrNotSpecifyWht && transactionItemWhtAmountTypeId === WhtAmountType.NotSpecify) {
        _transactionItem.toCurrencySubTotalForcalculateWHT = subTotalTransactionItemForcalculateWHT;
      } else if (!isNoneOrNotSpecifyWht && (transactionItemWhtAmount > 0 || transactionItemWhtAmount < 0)) {
        _transactionItem.toCurrencySubTotalForcalculateWHT = subTotalTransactionItemForcalculateWHT;
      }

      _transactionItem.toCurrencyNetTotal =
        subTotalTransactionItemForcalculateWHT + _transactionItem.toCurrencyVatTotal;

      _transactionItem.fromCurrencyPrice = CalculateWithCurrencyUid(
        _transactionItem.toCurrencyPrice,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      _transactionItem.fromCurrencyDiscount = CalculateWithCurrencyUid(
        _transactionItem.toCurrencyDiscount,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      _transactionItem.fromCurrencyWHTTotal = CalculateWithCurrencyUid(
        _transactionItem.toCurrencyWHTTotal,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      _transactionItem.fromCurrencyNetTotal = CalculateWithCurrencyUid(
        _transactionItem.toCurrencyNetTotal,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      _transactionItem.fromCurrencyVatTotal = CalculateWithCurrencyUid(
        _transactionItem.toCurrencyVatTotal,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      _transactionItem.fromCurrencyPreVatTotal = CalculateWithCurrencyUid(
        _transactionItem.toCurrencyPreVatTotal,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      _transactionItem.fromCurrencyZeroVatTotal = CalculateWithCurrencyUid(
        _transactionItem.toCurrencyZeroVatTotal,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      _transactionItem.fromCurrencyVatExemptedTotal = CalculateWithCurrencyUid(
        _transactionItem.toCurrencyVatExemptedTotal,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      _transactionItem.fromCurrencySubTotalForcalculateWHT = CalculateWithCurrencyUid(
        _transactionItem.toCurrencySubTotalForcalculateWHT,
        currencyExchangeRates,
        currencyRatio,
        currencyUId
      ).ToAccountingRoundUpNumber();

      const transactionItem = {
        transactionItemTotal: transactionItemTotal,
        price: transactionItemPrice,
        amount: transactionItemAmount,
        accountid: accountId,
        discount: transactionItemDiscount,
        discountType: transactionItemDiscountTypeId,
        vatTypeId: transactionItemVatTypeId,
        whtAmountTypeId: transactionItemWhtAmountTypeId,
        whtAmount: transactionItemWhtAmount,
        productTemplateId: productTemplateId,
        fixAssetTemplateId: fixedAssetTemplateId,
        description: transactionItemDescription,
        sequenceNumber: sequenceNumber + 1,
        isDescriptionOnly: isDescriptionOnly,
        transactionItemTypeId: transactionItemTypeId,
        taxIncomeTypeId: taxIncomeTypeId,
        preVatAmount: transactionItemPreVatAmount,
        vatAmount: transactionItemVatAmount,
      };
      transactionItemList.push(transactionItem);
    }

    return {
      transactionItemList: transactionItemList,
      total: total,
      sameProductVatTypeId: sameProductVatTypeId,
      sameProductVatTypeIdTransactionItemTypeProduct: sameProductVatTypeIdTransactionItemTypeProduct,
      isServiceOnly: isServiceOnly,
      totalForCalculateTransactionDiscount: totalForCalculateTransactionDiscount,
    };
  }
}

function GetReferenceDepositSummary(_transaction: any) {
  const referenceDepositSummary = {
    fromCurrencyNetTotal: 0,
    fromCurrencyVatTotal: 0,
    fromCurrencyPreVatTotal: 0,
    fromCurrencyZeroVatTotal: 0,
    fromCurrencyVatExemptedTotal: 0,
    toCurrencyNetTotal: 0,
    toCurrencyVatTotal: 0,
    toCurrencyPreVatTotal: 0,
    toCurrencyZeroVatTotal: 0,
    toCurrencyVatExemptedTotal: 0,
  };

  if (_transaction.referenceDepositList && _transaction.referenceDepositList.length > 0) {
    for (const referenceDeposit of _transaction.referenceDepositList) {
      referenceDepositSummary.fromCurrencyNetTotal += referenceDeposit.fromCurrencyNetTotal;
      referenceDepositSummary.fromCurrencyVatTotal += referenceDeposit.fromCurrencyVatTotal;
      referenceDepositSummary.fromCurrencyPreVatTotal += referenceDeposit.fromCurrencyPreVatTotal;
      referenceDepositSummary.fromCurrencyZeroVatTotal += referenceDeposit.fromCurrencyZeroVatTotal;
      referenceDepositSummary.fromCurrencyVatExemptedTotal += referenceDeposit.fromCurrencyVatExemptedTotal;
      referenceDepositSummary.toCurrencyNetTotal += referenceDeposit.toCurrencyNetTotal;
      referenceDepositSummary.toCurrencyVatTotal += referenceDeposit.toCurrencyVatTotal;
      referenceDepositSummary.toCurrencyPreVatTotal += referenceDeposit.toCurrencyPreVatTotal;
      referenceDepositSummary.toCurrencyZeroVatTotal += referenceDeposit.toCurrencyZeroVatTotal;
      referenceDepositSummary.toCurrencyVatExemptedTotal += referenceDeposit.toCurrencyVatExemptedTotal;
    }
  }

  return referenceDepositSummary;
}

function GetDiscountTransactionPerProduct(
  discount: any,
  discountType: any,
  transactionItemTotal: any,
  totalForCalculateTransactionDiscount: any
) {
  let discountTransactionPerProduct = 0;

  if (discountType === DiscountType.Percent) {
    discountTransactionPerProduct = peakUtility.PeakOperatorMultiply(
      peakUtility.PeakOperatorDivide(discount, 100),
      transactionItemTotal.ToNumber()
    );
  } else {
    discountTransactionPerProduct = peakUtility.PeakOperatorMultiply(
      peakUtility.PeakOperatorDivide(transactionItemTotal.ToNumber(), totalForCalculateTransactionDiscount.ToNumber()),
      discount.ToNumber()
    );
  }

  return discountTransactionPerProduct;
}

function GetDepositTransactionPerProduct(
  transactionItemVatTypeId: any,
  transactionItemTotal: any,
  fromCurrencyPreVatTotal: any,
  fromCurrencyZeroVatTotal: any,
  fromCurrencyVatExemptedTotal: any,
  fromCurrencyDepositPreVatTotal: any,
  fromCurrencyDepositZeroVatTotal: any,
  fromCurrencyDepositVatExemptedTotal: any
) {
  let depositTransactionPerProduct = 0;

  switch (transactionItemVatTypeId.ToNumber()) {
    case ProductVatType.SevenPercent:
      depositTransactionPerProduct = peakUtility.PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(transactionItemTotal.ToNumber(), fromCurrencyPreVatTotal.ToNumber()),
        fromCurrencyDepositPreVatTotal.ToNumber()
      );
      break;
    case ProductVatType.ZeroPercent:
      depositTransactionPerProduct = peakUtility.PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(transactionItemTotal.ToNumber(), fromCurrencyZeroVatTotal.ToNumber()),
        fromCurrencyDepositZeroVatTotal.ToNumber()
      );
      break;
    default:
      depositTransactionPerProduct = peakUtility.PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(transactionItemTotal.ToNumber(), fromCurrencyVatExemptedTotal.ToNumber()),
        fromCurrencyDepositVatExemptedTotal.ToNumber()
      );
      break;
  }

  return depositTransactionPerProduct;
}

function GetTransactionItemSummary(_transaction: any) {
  let vatExemptedTotal = 0;
  let zeroVatTotal = 0;
  let sevenVatTotal = 0;
  let whtTotal = 0;
  let amountBeforeDiscount = 0;

  const transactionItemModel: any = GetTransactionItemList(_transaction);
  const referenceDepositSummary: any = GetReferenceDepositSummary(_transaction);
  const isOnlyNoneOrNotSpecifyWht =
    transactionItemModel.transactionItemList.filter(
      (transactionItem: any) => transactionItem.whtAmount > 0 || transactionItem.whtAmount < 0
    ).length > 0
      ? false
      : true;
  const isHaveSomeNotSpecifyWht =
    transactionItemModel.transactionItemList.filter(
      (transactionItem: any) => transactionItem.whtAmountTypeId === WhtAmountType.NotSpecify
    ).length > 0;
  const isNoneOrNotSpecifyWht = isHaveSomeNotSpecifyWht && isOnlyNoneOrNotSpecifyWht;
  let subTotalForCalculate = 0;

  for (const transactionItem of transactionItemModel.transactionItemList) {
    let discountTransactionPerProduct = 0;
    amountBeforeDiscount += transactionItem.transactionItemTotal;
    if (transactionItem.transactionItemTotal > 0) {
      if (_transaction.transactionDiscount.discountType === 1) {
        discountTransactionPerProduct = peakUtility.PeakOperatorMultiply(
          peakUtility.PeakOperatorDivide(_transaction.transactionDiscount.value, 100),
          transactionItem.transactionItemTotal
        );
      } else {
        discountTransactionPerProduct = peakUtility.PeakOperatorMultiply(
          peakUtility.PeakOperatorDivide(
            transactionItem.transactionItemTotal,
            transactionItemModel.totalForCalculateTransactionDiscount
          ),
          _transaction.transactionDiscount.value
        );
      }
    }
    //Depend on taxStatus
    const transactionItemTotalWithDiscount = peakUtility.PeakOperatorSubtract(
      transactionItem.transactionItemTotal,
      discountTransactionPerProduct
    );

    let transactionItemPreVatTotalWithDiscount = 0;
    if (_transaction.taxStatus.value === TaxTypeId.IncludeTax) {
      let discountForIncludeTax = 0;
      if (transactionItem.vatTypeId === ProductVatType.SevenPercent) {
        discountForIncludeTax = (discountTransactionPerProduct * 100) / 107;
      } else {
        discountForIncludeTax = discountTransactionPerProduct;
      }
      transactionItemPreVatTotalWithDiscount = peakUtility.PeakOperatorSubtract(
        transactionItem.preVatAmount,
        discountForIncludeTax
      );
    } else {
      transactionItemPreVatTotalWithDiscount = peakUtility.PeakOperatorSubtract(
        transactionItem.preVatAmount,
        discountTransactionPerProduct
      );
    }

    if (isNoneOrNotSpecifyWht && transactionItem.whtAmountTypeId === WhtAmountType.NotSpecify) {
      subTotalForCalculate = peakUtility.PeakOperatorAdd(subTotalForCalculate, transactionItemPreVatTotalWithDiscount);
    } else if (!isNoneOrNotSpecifyWht && (transactionItem.whtAmount > 0 || transactionItem.whtAmount < 0)) {
      subTotalForCalculate = peakUtility.PeakOperatorAdd(subTotalForCalculate, transactionItemPreVatTotalWithDiscount);
    }

    switch (transactionItem.vatTypeId.ToNumber()) {
      case 3:
        sevenVatTotal = peakUtility.PeakOperatorAdd(sevenVatTotal, transactionItemTotalWithDiscount);
        break;
      case 2:
        zeroVatTotal = peakUtility.PeakOperatorAdd(zeroVatTotal, transactionItemTotalWithDiscount);
        break;
      default:
        vatExemptedTotal = peakUtility.PeakOperatorAdd(vatExemptedTotal, transactionItemTotalWithDiscount);
        break;
    }
  }

  for (const transactionItem of transactionItemModel.transactionItemList) {
    let depositTransactionPerProduct = 0;
    let discountTransactionPerProduct = 0;
    if (transactionItem.transactionItemTotal > 0) {
      discountTransactionPerProduct = GetDiscountTransactionPerProduct(
        _transaction.transactionDiscount.value,
        _transaction.transactionDiscount.discountType,
        transactionItem.transactionItemTotal,
        transactionItemModel.totalForCalculateTransactionDiscount
      );
      depositTransactionPerProduct = GetDepositTransactionPerProduct(
        transactionItem.vatTypeId,
        transactionItem.transactionItemTotal,
        sevenVatTotal,
        zeroVatTotal,
        vatExemptedTotal,
        referenceDepositSummary.toCurrencyPreVatTotal,
        referenceDepositSummary.toCurrencyZeroVatTotal,
        referenceDepositSummary.toCurrencyVatExemptedTotal
      );
    }

    const transactionItemTotalWithDiscount = peakUtility.PeakOperatorSubtract(
      transactionItem.transactionItemTotal,
      discountTransactionPerProduct
    );

    const transactionItemTotalWithDepositAndDiscount = peakUtility.PeakOperatorSubtract(
      transactionItemTotalWithDiscount,
      depositTransactionPerProduct
    );

    if (transactionItem.whtAmount != null && transactionItemTotalWithDepositAndDiscount != 0) {
      if (transactionItemTotalWithDepositAndDiscount === transactionItem.transactionItemTotal) {
        whtTotal = peakUtility.PeakOperatorAdd(transactionItem.whtAmount, whtTotal);
      } else {
        const whtAmountPercent = peakUtility.PeakOperatorDivide(
          peakUtility.PeakOperatorMultiply(transactionItem.whtAmount, 100),
          transactionItem.transactionItemTotal
        );

        const whtTransactionItemWithDiscount = peakUtility.PeakOperatorDivide(
          peakUtility.PeakOperatorMultiply(whtAmountPercent, transactionItemTotalWithDepositAndDiscount),
          100
        );

        whtTotal = peakUtility.PeakOperatorAdd(whtTransactionItemWithDiscount, whtTotal);
      }
    }
  }

  const total = peakUtility.PeakOperatorAdd(peakUtility.PeakOperatorAdd(vatExemptedTotal, zeroVatTotal), sevenVatTotal);

  return {
    amountBeforeDiscount: amountBeforeDiscount,
    vatExemptedTotal: vatExemptedTotal,
    zeroVatTotal: zeroVatTotal,
    sevenVatTotal: sevenVatTotal,
    total: total,
    subTotalForCalculate: subTotalForCalculate,
    whtTotal: whtTotal,
    isNoneOrNotSpecifyWht: isNoneOrNotSpecifyWht,
    isServiceOnly: transactionItemModel.isServiceOnly,
    sameProductVatTypeId: transactionItemModel.sameProductVatTypeId,
    sameProductVatTypeIdTransactionItemTypeProduct: transactionItemModel.sameProductVatTypeIdTransactionItemTypeProduct,
  };
}

function GetTransactionSummary(_transaction: any) {
  const taxStatus = _transaction.taxStatus.value;
  const currencyRatio = _transaction.transactionCurrencySummary.ratio;
  const currencyExchangeRates = _transaction.transactionCurrencySummary.exchangeRate;
  const referenceDepositSummary = GetReferenceDepositSummary(_transaction);
  const transactionItemSummaryModel = GetTransactionItemSummary(_transaction);
  const transactionWht: any = {
    subTotalForCalculate: transactionItemSummaryModel.subTotalForCalculate,
    whtTotal: transactionItemSummaryModel.whtTotal,
    isServiceOnly: transactionItemSummaryModel.isServiceOnly,
    isNoneOrNotSpecifyWht: transactionItemSummaryModel.isNoneOrNotSpecifyWht,
    sameProductVatTypeId: transactionItemSummaryModel.sameProductVatTypeId,
    sameProductVatTypeIdTransactionItemTypeProduct:
      transactionItemSummaryModel.sameProductVatTypeIdTransactionItemTypeProduct,
  };
  let vatExemptedTotal: any = peakUtility
    .PeakOperatorDivide(
      peakUtility.PeakOperatorMultiply(transactionItemSummaryModel.vatExemptedTotal, currencyExchangeRates),
      currencyRatio
    )
    .ToAccountingRoundUp();
  let zeroVatTotal: any = peakUtility
    .PeakOperatorDivide(
      peakUtility.PeakOperatorMultiply(transactionItemSummaryModel.zeroVatTotal, currencyExchangeRates),
      currencyRatio
    )
    .ToAccountingRoundUp();

  vatExemptedTotal = peakUtility.PeakOperatorSubtract(
    vatExemptedTotal,
    referenceDepositSummary.fromCurrencyVatExemptedTotal
  );

  zeroVatTotal = peakUtility.PeakOperatorSubtract(zeroVatTotal, referenceDepositSummary.fromCurrencyZeroVatTotal);

  const currencyVatExemptedTotal: any = transactionItemSummaryModel.vatExemptedTotal.ToAccountingRoundUp();
  const currencyZeroVatTotal: any = transactionItemSummaryModel.zeroVatTotal.ToAccountingRoundUp();
  let preVatTotal: any = 0;
  let vat: any = 0;
  let netAmount: any = 0;
  let currencyPreVatTotal: any = 0;
  let currencyVatTotal: any = 0;
  let currencyNetAmount: any = 0;
  const currencyAmountBeforeDiscount: any = transactionItemSummaryModel.amountBeforeDiscount.ToAccountingRoundUp();
  let currencyReferenceDepositTotal: any = 0;
  let currencyAmountAfterDiscount: any = 0;
  if (taxStatus.ToNumber() === TaxTypeId.ExcludeTax) {
    vat = peakUtility
      .PeakOperatorDivide(
        peakUtility.PeakOperatorMultiply(
          peakUtility.PeakOperatorDivide(
            peakUtility.PeakOperatorMultiply(transactionItemSummaryModel.sevenVatTotal, currencyExchangeRates),
            currencyRatio
          ),
          vatPercent
        ),
        100
      )
      .ToAccountingRoundUp();
    vat = peakUtility.PeakOperatorSubtract(vat, referenceDepositSummary.fromCurrencyVatTotal);

    preVatTotal = peakUtility
      .PeakOperatorDivide(
        peakUtility.PeakOperatorMultiply(transactionItemSummaryModel.sevenVatTotal, currencyExchangeRates),
        currencyRatio
      )
      .ToAccountingRoundUp();
    preVatTotal = peakUtility.PeakOperatorSubtract(preVatTotal, referenceDepositSummary.fromCurrencyPreVatTotal);

    netAmount = peakUtility
      .PeakOperatorAdd(
        peakUtility.PeakOperatorAdd(
          peakUtility.PeakOperatorAdd(
            preVatTotal.ToAccountingRoundUpNumber(),
            zeroVatTotal.ToAccountingRoundUpNumber()
          ),
          vatExemptedTotal.ToAccountingRoundUpNumber()
        ),
        vat.ToAccountingRoundUpNumber()
      )
      .ToAccountingRoundUp();

    currencyVatTotal = peakUtility
      .PeakOperatorSubtract(
        peakUtility.PeakOperatorDivide(
          peakUtility.PeakOperatorMultiply(transactionItemSummaryModel.sevenVatTotal, vatPercent),
          100
        ),
        referenceDepositSummary.toCurrencyVatTotal
      )
      .ToAccountingRoundUpNumber();
    currencyPreVatTotal = peakUtility
      .PeakOperatorSubtract(transactionItemSummaryModel.sevenVatTotal, referenceDepositSummary.toCurrencyPreVatTotal)
      .ToAccountingRoundUpNumber();
    currencyNetAmount = peakUtility
      .PeakOperatorAdd(
        peakUtility.PeakOperatorAdd(
          peakUtility.PeakOperatorAdd(
            currencyPreVatTotal.ToAccountingRoundUpNumber(),
            currencyZeroVatTotal.ToAccountingRoundUpNumber()
          ),
          currencyVatExemptedTotal.ToAccountingRoundUpNumber()
        ),
        currencyVatTotal.ToAccountingRoundUpNumber()
      )
      .ToAccountingRoundUp();

    currencyReferenceDepositTotal = peakUtility
      .PeakOperatorSubtract(referenceDepositSummary.toCurrencyNetTotal, referenceDepositSummary.fromCurrencyVatTotal)
      .ToAccountingRoundUpNumber();
  } else {
    netAmount = peakUtility
      .PeakOperatorDivide(
        peakUtility.PeakOperatorMultiply(transactionItemSummaryModel.total, currencyExchangeRates),
        currencyRatio
      )
      .ToAccountingRoundUp();

    netAmount = peakUtility
      .PeakOperatorSubtract(netAmount, referenceDepositSummary.fromCurrencyNetTotal)
      .ToAccountingRoundUpNumber();

    const totalWithVat = peakUtility.PeakOperatorSubtract(
      peakUtility.PeakOperatorSubtract(netAmount, zeroVatTotal),
      vatExemptedTotal
    );
    vat = peakUtility
      .PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(totalWithVat, peakUtility.PeakOperatorAdd(100, vatPercent)),
        vatPercent
      )
      .ToAccountingRoundUp();
    preVatTotal = peakUtility
      .PeakOperatorSubtract(
        peakUtility.PeakOperatorSubtract(peakUtility.PeakOperatorSubtract(netAmount, vat), zeroVatTotal),
        vatExemptedTotal
      )
      .ToAccountingRoundUp();

    currencyNetAmount = peakUtility
      .PeakOperatorSubtract(transactionItemSummaryModel.total, referenceDepositSummary.toCurrencyNetTotal)
      .ToAccountingRoundUpNumber();
    const currencyTotalWithVat = peakUtility.PeakOperatorSubtract(
      peakUtility.PeakOperatorSubtract(currencyNetAmount, currencyZeroVatTotal),
      currencyVatExemptedTotal
    );
    currencyVatTotal = peakUtility
      .PeakOperatorMultiply(
        peakUtility.PeakOperatorDivide(currencyTotalWithVat, peakUtility.PeakOperatorAdd(100, vatPercent)),
        vatPercent
      )
      .ToAccountingRoundUp();
    currencyPreVatTotal = peakUtility
      .PeakOperatorSubtract(
        peakUtility.PeakOperatorSubtract(
          peakUtility.PeakOperatorSubtract(currencyNetAmount, currencyVatTotal),
          currencyZeroVatTotal
        ),
        currencyVatExemptedTotal
      )
      .ToAccountingRoundUp();

    currencyReferenceDepositTotal = referenceDepositSummary.toCurrencyNetTotal.ToAccountingRoundUpNumber();
  }

  currencyAmountAfterDiscount = peakUtility
    .PeakOperatorSubtract(transactionItemSummaryModel.total, currencyReferenceDepositTotal)
    .ToAccountingRoundUpNumber();

  const transactionSummary = {
    netAmount: netAmount,
    vatTotal: vat,
    preVatTotal: preVatTotal,
    zeroVatTotal: zeroVatTotal,
    vatExemptedTotal: vatExemptedTotal,
    whtTotal: peakUtility
      .PeakOperatorDivide(
        peakUtility.PeakOperatorMultiply(transactionWht.whtTotal, currencyExchangeRates),
        currencyRatio
      )
      .ToAccountingRoundUpNumber(),
    subTotalForCalculateWht: peakUtility
      .PeakOperatorDivide(
        peakUtility.PeakOperatorMultiply(transactionWht.subTotalForCalculate, currencyExchangeRates),
        currencyRatio
      )
      .ToAccountingRoundUpNumber(),
    isServiceOnly: transactionWht.isServiceOnly,
    isNoneOrNotSpecifyWht: transactionWht.isNoneOrNotSpecifyWht,
    sameProductVatTypeId: transactionWht.sameProductVatTypeId.ToNumber(),
    sameProductVatTypeIdTransactionItemTypeProduct: transactionWht.sameProductVatTypeIdTransactionItemTypeProduct.ToNumber(),
    discount: CalculateWithCurrencyUid(
      _transaction.transactionDiscount.value.ToNumber(),
      currencyExchangeRates,
      currencyRatio,
      _transaction.transactionCurrencySummary.toCurrencyUId
    ).ToAccountingRoundUpNumber(),
  };
  const transactionCurrencySummary = {
    netAmount: currencyNetAmount,
    vatTotal: currencyVatTotal,
    preVatTotal: currencyPreVatTotal,
    zeroVatTotal: currencyZeroVatTotal,
    vatExemptedTotal: currencyVatExemptedTotal,
    whtTotal: transactionWht.whtTotal.ToAccountingRoundUpNumber(),
    subTotalForCalculateWht: transactionWht.subTotalForCalculate.ToAccountingRoundUpNumber(),
    amountBeforeDiscount: currencyAmountBeforeDiscount.ToAccountingRoundUpNumber(),
    referenceDepositTotal: currencyReferenceDepositTotal.ToAccountingRoundUpNumber(),
    amountAfterDiscount: currencyAmountAfterDiscount.ToAccountingRoundUpNumber(),
    discount: _transaction.transactionDiscount.value.ToNumber(),
  };
  return {
    transactionSummary: transactionSummary,
    transactionCurrencySummary: transactionCurrencySummary,
    referenceDepositSummary: referenceDepositSummary,
  };
}

export function SetTransactionSummary(_transaction: any) {
  const transactionSummaryModel = GetTransactionSummary(_transaction);
  if (!_transaction.isNotCalculateTransactionSummary) {
    _transaction.transactionCurrencySummary.discount = transactionSummaryModel.transactionCurrencySummary.discount;
    _transaction.transactionCurrencySummary.vatExemptedTotal = transactionSummaryModel.transactionCurrencySummary.vatExemptedTotal.FormatMoney();
    _transaction.transactionCurrencySummary.zeroVatTotal = transactionSummaryModel.transactionCurrencySummary.zeroVatTotal.FormatMoney();
    _transaction.transactionCurrencySummary.netAmount = transactionSummaryModel.transactionCurrencySummary.netAmount.FormatMoney();
    _transaction.transactionCurrencySummary.whtTotal = transactionSummaryModel.transactionCurrencySummary.whtTotal.FormatMoney();
    _transaction.transactionCurrencySummary.amountBeforeDiscount = transactionSummaryModel.transactionCurrencySummary.amountBeforeDiscount.FormatMoney();
    _transaction.transactionCurrencySummary.referenceDepositTotal = transactionSummaryModel.transactionCurrencySummary.referenceDepositTotal.FormatMoney();
    _transaction.transactionCurrencySummary.amountAfterDiscount = transactionSummaryModel.transactionCurrencySummary.amountAfterDiscount.FormatMoney();

    _transaction.transactionSummary.discount = transactionSummaryModel.transactionSummary.discount;
    _transaction.transactionSummary.vatExemptedTotal = transactionSummaryModel.transactionSummary.vatExemptedTotal.FormatMoney();
    _transaction.transactionSummary.zeroVatTotal = transactionSummaryModel.transactionSummary.zeroVatTotal.FormatMoney();

    if (_transaction.referenceDepositSummary) {
      _transaction.referenceDepositSummary.fromCurrencyDepositVatTotal = transactionSummaryModel.referenceDepositSummary.fromCurrencyVatTotal.FormatMoney();
      _transaction.referenceDepositSummary.fromCurrencyDepositPreVatTotal = transactionSummaryModel.referenceDepositSummary.fromCurrencyPreVatTotal.FormatMoney();
      _transaction.referenceDepositSummary.fromCurrencyDepositZeroVatTotal = transactionSummaryModel.referenceDepositSummary.fromCurrencyZeroVatTotal.FormatMoney();
      _transaction.referenceDepositSummary.fromCurrencyDepositVatExemptedTotal = transactionSummaryModel.referenceDepositSummary.fromCurrencyVatExemptedTotal.FormatMoney();
      _transaction.referenceDepositSummary.toCurrencyDepositVatTotal = transactionSummaryModel.referenceDepositSummary.toCurrencyVatTotal.FormatMoney();
      _transaction.referenceDepositSummary.toCurrencyDepositPreVatTotal = transactionSummaryModel.referenceDepositSummary.toCurrencyPreVatTotal.FormatMoney();
      _transaction.referenceDepositSummary.toCurrencyDepositZeroVatTotal = transactionSummaryModel.referenceDepositSummary.toCurrencyZeroVatTotal.FormatMoney();
      _transaction.referenceDepositSummary.toCurrencyDepositVatExemptedTotal = transactionSummaryModel.referenceDepositSummary.toCurrencyVatExemptedTotal.FormatMoney();
    }

    if (!_transaction.transactionItemDisabled && !_transaction.isNotAuto) {
      _transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
        transactionSummaryModel.transactionCurrencySummary.preVatTotal;
      _transaction.transactionCurrencySummary.vat.preVatTotal = transactionSummaryModel.transactionCurrencySummary.preVatTotal.FormatMoney();
      _transaction.transactionCurrencySummary.vat.vatTotalDefualt =
        transactionSummaryModel.transactionCurrencySummary.vatTotal;
      _transaction.transactionCurrencySummary.vat.vatTotal = transactionSummaryModel.transactionCurrencySummary.vatTotal.FormatMoney();
      _transaction.transactionSummary.vat.preVatTotalDefualt = transactionSummaryModel.transactionSummary.preVatTotal;
      _transaction.transactionSummary.vat.preVatTotal = transactionSummaryModel.transactionSummary.preVatTotal.FormatMoney();
      _transaction.transactionSummary.vat.vatTotalDefualt = transactionSummaryModel.transactionSummary.vatTotal;
      _transaction.transactionSummary.vat.vatTotal = transactionSummaryModel.transactionSummary.vatTotal.FormatMoney();
      _transaction.transactionSummary.isServiceOnly = transactionSummaryModel.transactionSummary.isServiceOnly;
      _transaction.transactionSummary.isNoneOrNotSpecifyWht =
        transactionSummaryModel.transactionSummary.isNoneOrNotSpecifyWht;
      _transaction.transactionSummary.sameProductVatType =
        transactionSummaryModel.transactionSummary.sameProductVatTypeId;
      _transaction.transactionSummary.sameProductVatTypeIdTransactionItemTypeProduct =
        transactionSummaryModel.transactionSummary.sameProductVatTypeIdTransactionItemTypeProduct;
    }
    _transaction.transactionCurrencySummary.vat.disabled =
      _transaction.transactionSummary.sameProductVatType === ProductVatType.None;
    _transaction.transactionSummary.vat.disabled =
      _transaction.transactionSummary.sameProductVatType === ProductVatType.None;
    _transaction.transactionCurrencySummary.vat.isActive = false;
    _transaction.transactionSummary.vat.isActive = false;

    _transaction.transactionSummary.netAmount = transactionSummaryModel.transactionSummary.netAmount.FormatMoney();
    _transaction.transactionSummary.subTotalForCalculateWht =
      transactionSummaryModel.transactionSummary.subTotalForCalculateWht;
    _transaction.transactionSummary.paymentWht = {
      whtTotal: transactionSummaryModel.transactionSummary.whtTotal.FormatMoney(),
      paymentNetAmount: peakUtility
        .PeakOperatorSubtract(
          transactionSummaryModel.transactionSummary.netAmount,
          transactionSummaryModel.transactionSummary.whtTotal
        )
        .FormatMoney(),
      isShow: transactionSummaryModel.transactionSummary.whtTotal != 0,
    };
    _transaction.transactionSummary.remainPaymentNetAmount = transactionSummaryModel.transactionSummary.netAmount;
    _transaction.transactionSummary.remainWhtPaymentNetAmount = transactionSummaryModel.transactionSummary.whtTotal;
  }
}

function DiscountValidation(transactionItem: any) {
  const price = transactionItem.price.value.ToNumber();
  const discount = transactionItem.discount.value.ToNumber();
  if (price >= 0) {
    transactionItem.discount.disabled = false;
    if (transactionItem.discount.discountTypeId == DiscountType.Currency) {
      transactionItem.discount.validateError = discount > price ? true : false;
    } else if (transactionItem.discount.discountTypeId == DiscountType.Percent) {
      transactionItem.discount.validateError = discount > 100 ? true : false;
    }
  } else {
    transactionItem.discount.value = "0.00";
    transactionItem.discount.validateError = false;
    transactionItem.discount.disabled = true;
  }
}

function TransactionItemValidation(transactionItem: any, _transaction: any) {
  transactionItem.description.validateError = transactionItem.description.text.toString().length > 1000;
  transactionItem.amount.validateError = transactionItem.amount.value.ToNumber() > inputMaxNumber;
  transactionItem.price.validateError =
    transactionItem.price.value.ToNumber() > inputMaxNumber ||
    transactionItem.price.value.ToNumber() < inputMinNumber ||
    (transactionItem.price.value.ToNumber() < 0 &&
      transactionItem.productTemplate.id != 0 &&
      transactionItem.productTemplate.productTypeId === ProductType.Inventory);
  transactionItem.itemWht.validateError =
    transactionItem.itemWht.value !== null &&
    transactionItem.itemPreVatTotal.ToNumber() > 0 &&
    transactionItem.itemWht.value.ToNumber() > transactionItem.itemPreVatTotal.ToNumber()
      ? true
      : false;
  DiscountValidation(transactionItem);

  //set TransactionItem ValidateError
  if (
    !transactionItem.description.validateError &&
    !transactionItem.amount.validateError &&
    !transactionItem.price.validateError &&
    !transactionItem.discount.validateError &&
    !transactionItem.itemWht.validateError
  ) {
    transactionItem.isValidateError = false;
  } else {
    transactionItem.isValidateError = true;
  }

  if (_transaction.taxStatus.value == TaxTypeId.None) {
    transactionItem.vatTypeId.disabled = true;
  } else {
    transactionItem.vatTypeId.disabled = false;
  }
}

function IsTransactionValidateTransactionItem(_transaction: any) {
  let isCanValidate = true;
  switch (_transaction.transactionType) {
    case TransactionType.Receipt:
      if (
        _transaction.reference.referenceTypeId === TransactionType.Invoice ||
        _transaction.reference.referenceTypeId === TransactionType.BillingNote
      ) {
        isCanValidate = false;
      }
      break;
  }
  return isCanValidate;
}

function TransactionItemListValidate(_transaction: any) {
  if (
    IsTransactionValidateTransactionItem(_transaction) &&
    _transaction.transactionItemList &&
    _transaction.transactionItemList.length > 0
  ) {
    let countTransactionItemEmpty = 0;
    let isValidateError = false;
    _transaction.transactionItemList.forEach((transactionItem: any) => {
      if (
        (!transactionItem.isDescriptionOnly &&
          transactionItem.productTemplate.id === 0 &&
          transactionItem.account.id === 0 &&
          transactionItem.description.text === "" &&
          transactionItem.price.value.ToNumber() === 0 &&
          transactionItem.discount.value.ToNumber() === 0) ||
        (transactionItem.isDescriptionOnly && transactionItem.description.text === "")
      ) {
        countTransactionItemEmpty += 1;
      } else if (transactionItem.isValidateError || transactionItem.description.text === "") {
        isValidateError = true;
      }
    });

    if (_transaction.transactionItemList.length === countTransactionItemEmpty) {
      _transaction.isValidateError = true;
    } else {
      _transaction.isValidateError = isValidateError;
    }
  }
}

function SummaryValidation(_transaction: any) {
  const transactionSummaryModel = GetTransactionSummary(_transaction);
  const transactionItemModel = GetTransactionItemSummary(_transaction);
  const transactionDiscountValue = _transaction.transactionDiscount.value.ToNumber();
  let totalPrice = 0;
  for (const item of _transaction.transactionItemList) {
    totalPrice += item.price.value.ToNumber();
  }
  if (transactionSummaryModel.transactionSummary.sameProductVatTypeId === ProductVatType.NotDefined) {
    _transaction.transactionDiscount.disabled = true;
  } else {
    _transaction.transactionDiscount.disabled = false;
    const transactionItemFindError = _transaction.transactionItemList.find(
      (transactionItem: any) => transactionItem.discount.validateError === true
    );
    const isTransactionItemDiscountError = transactionItemFindError === undefined ? false : true;
    if (!isTransactionItemDiscountError) {
      if (transactionItemModel.total === 0) {
        _transaction.transactionDiscount.validateError =
          transactionDiscountValue > 0 && transactionDiscountValue !== totalPrice;
      } else {
        if (_transaction.transactionDiscount.discountType == DiscountType.Percent) {
          _transaction.transactionDiscount.validateError = transactionDiscountValue > 100;
        } else {
          _transaction.transactionDiscount.validateError =
            transactionSummaryModel.transactionCurrencySummary.netAmount.ToNumber() < 0 && transactionDiscountValue > 0;
        }
      }
      if (transactionDiscountValue < 0) {
        _transaction.transactionDiscount.validateError = true;
      }
    }
  }
}

function PaymentValidation(_transaction: any) {
  const isPaymentActive =
    _transaction.payment.paymentGroupList.find((paymentGroup: any) => paymentGroup.isPaymentActive == true) ===
    undefined
      ? false
      : true;
  if (_transaction.payment && isPaymentActive) {
    const paymentAllGroupTotal = _transaction.payment.paymentAllGroupTotal.ToNumber().ToAccountingRoundUpNumber();
    const netAmount = _transaction.transactionSummary.remainPaymentNetAmount.ToNumber().ToAccountingRoundUpNumber();
    const paymentTransactionBankAccountIndex = 0;
    const subTotal =
      _transaction.transactionSummary.zeroVatTotal.ToNumber() +
      _transaction.transactionSummary.vatExemptedTotal.ToNumber() +
      _transaction.transactionSummary.vat.preVatTotal.ToNumber();
    let paymentAmountValidate = false;
    if (
      (_transaction.transactionType === TransactionType.Receipt && _transaction.financeType === FinanceType.InFlow) ||
      _transaction.transactionType === TransactionType.BillingNote
    ) {
      paymentAmountValidate = paymentAllGroupTotal !== netAmount;
      _transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[
        paymentTransactionBankAccountIndex
      ].inputValidationError = paymentAllGroupTotal !== netAmount;
    } else {
      paymentAmountValidate = paymentAllGroupTotal > netAmount;
      _transaction.payment.paymentGroupList[0].paymentTransactionBankAccountList[
        paymentTransactionBankAccountIndex
      ].inputValidationError = paymentAllGroupTotal > netAmount;
    }
    const paymentGroupValidate =
      _transaction.payment.paymentGroupList.find((paymentGroup: any) => paymentGroup.validateError == true) ===
      undefined
        ? false
        : true;
    const paymentGroupDateValidate =
      _transaction.payment.paymentGroupList.find((paymentGroup: any) => !paymentGroup.paymentGroupDate) === undefined
        ? false
        : true;
    const paymentWhtValidate =
      _transaction.payment.paymentGroupList.reduce(
        (total: any, item: any) => peakUtility.PeakOperatorAdd(total, item.whtPayment.whtAmount.ToNumber() || 0),
        0
      ) > subTotal;
    _transaction.payment.isValidateError =
      paymentGroupValidate || paymentAmountValidate || paymentWhtValidate || paymentGroupDateValidate;
  } else {
    _transaction.payment.isValidateError = false;
  }
}

export function CheckErrorValueInput(_transaction: any) {
  _transaction.transactionItemList.forEach((transactionItem: any) => {
    TransactionItemValidation(transactionItem, _transaction);
  });
  TransactionItemListValidate(_transaction);
  SummaryValidation(_transaction);
  switch (_transaction.transactionType) {
    case TransactionType.Receipt:
    case TransactionType.Invoice:
    case TransactionType.CreditNote:
      PaymentValidation(_transaction);
      break;
  }
}

export function GetCreateTransactionItemForAI(transactionDetailItem: any, expenseType = ExpenseType.None) {
  const transactionItem = GetCreateTransactionItemDefualt(expenseType);
  transactionItem.isDescriptionOnly = transactionDetailItem.isDescriptionOnly;
  transactionItem.productTemplate.id = transactionDetailItem.productTemplateId;
  transactionItem.account.id = transactionDetailItem.accountId;
  if (transactionItem.productTemplate.id > 0) {
    transactionItem.productTemplate.isNotAuto = true;
  }
  if (transactionItem.account.id > 0 || transactionItem.productTemplate.isNotAuto) {
    transactionItem.account.isNotAuto = true;
  }
  transactionItem.description.text = transactionDetailItem.description;
  return transactionItem;
}

export function GetCreateTransactionItemForAIChartOfAccount(chartOfAccountId: any, expenseType = ExpenseType.None) {
  const transactionItem = GetCreateTransactionItemDefualt(expenseType);
  transactionItem.account.id = chartOfAccountId;
  transactionItem.account.isNotAuto = false;
  return transactionItem;
}

export function GetCreateTransactionItemFromTransactionItem(
  transactionDetailItem: any,
  isCanEdit = true,
  expenseType = ExpenseType.None
) {
  const transactionItem = GetCreateTransactionItemDefualt(expenseType);
  transactionItem.isDescriptionOnly = transactionDetailItem.isDescriptionOnly;
  transactionItem.productTemplate.id = transactionDetailItem.productTemplateId;
  transactionItem.productTemplate.disabled = !isCanEdit;
  if (transactionItem.productTemplate.id > 0) {
    transactionItem.productTemplate.isNotAuto = true;
  }
  transactionItem.account.id = transactionDetailItem.accountId;
  if (transactionItem.account.id > 0 || transactionItem.productTemplate.isNotAuto) {
    transactionItem.account.isNotAuto = true;
  }
  transactionItem.account.disabled = !isCanEdit;
  transactionItem.description.text = transactionDetailItem.description;
  transactionItem.description.disabled = !isCanEdit;
  transactionItem.amount.value = transactionDetailItem.amount.ToPeakTransactionItemFormat();
  transactionItem.amount.disabled = !isCanEdit;
  transactionItem.price.value = transactionDetailItem.price.ToPeakTransactionItemFormat();
  transactionItem.price.disabled = !isCanEdit;
  transactionItem.discount.value = transactionDetailItem.discount.ToPeakTransactionItemFormat();
  transactionItem.discount.discountTypeId = transactionDetailItem.discountType;
  transactionItem.discount.disabled = !isCanEdit;
  transactionItem.vatTypeId.value = transactionDetailItem.vatType;
  transactionItem.vatTypeId.disabled = !isCanEdit;
  transactionItem.itemWht.value = transactionDetailItem.whtAmount;
  transactionItem.itemWht.whtAmountType = transactionDetailItem.whtAmountType;
  transactionItem.itemWht.disabled = !isCanEdit;
  if (transactionItem.itemWht.whtAmountType !== 0) {
    transactionItem.itemWht.isNotAuto = true;
  }
  return transactionItem;
}
export function SetCreateClassificationTransaction(classificationList: Array<ClassificationListModel>) {
  let count = 0;
  const classificationTransactionList = [];
  if (classificationList && classificationList.length > 0) {
    for (const classification of classificationList) {
      if (!classification.isArchived && count < 4) {
        count++;
        const classificationTransaction = {
          classificationId: classification.id,
          classificationItemList: Array<ClassificationItemListModel>(),
          classification: classification,
          isSetDefaultValue: false,
        };
        classificationTransactionList.push(classificationTransaction);
      }
    }
    return classificationTransactionList;
  }
}
